
<div
  class="progress-ring"
  [style.width.px]="size()"
  [style.height.px]="size()"
  role="progressbar"
  [attr.aria-valuenow]="percent()"
  aria-valuemin="0"
  aria-valuemax="100"
>
  <svg
    class="progress-ring__svg"
    [attr.width]="size()"
    [attr.height]="size()"
    [attr.viewBox]="viewBox()"
  >
    <circle
      class="progress-ring__track"
      [attr.cx]="center()"
      [attr.cy]="center()"
      [attr.r]="radius()"
      [attr.stroke-width]="strokeWidth()"
      fill="none"
    />
    <circle
      class="progress-ring__fill"
      [attr.cx]="center()"
      [attr.cy]="center()"
      [attr.r]="radius()"
      [attr.stroke-width]="strokeWidth()"
      fill="none"
      [attr.stroke-dasharray]="circumference()"
      [attr.stroke-dashoffset]="dashOffset()"
      stroke-linecap="round"
      [attr.transform]="'rotate(-90 ' + center() + ' ' + center() + ')'"
    />
  </svg>

  @if (showLabel()) {
    <span class="progress-ring__label">{{ percent() }}%</span>
  }
</div>
